import { Card } from '@heroui/react';

function SkillCard({ group }) {
  return (
    <Card className="skill-card">
      <Card.Header className="card-heading">
        <h3>{group.type}</h3>
      </Card.Header>
      <Card.Content className="skill-list">
        {group.skills.map((skill) => (
          <div className="skill-row" key={skill}>
            <span>{skill}</span>
          </div>
        ))}
      </Card.Content>
    </Card>
  );
}

export default SkillCard;
